import React from 'react';
import { Navigate } from 'react-router-dom';
import jwtUtils from '../utilities/jwtUtils'; // Asegúrate de tener esta utilidad para decodificar el token

const ProtectedRoute = ({ element }) => {
  const payload = jwtUtils.getValidRefreshTokenPayload();

  if (payload) {
    const rol = payload.rol;

     // Redirigir según el rol del usuario
     switch (rol) {
      case 'admin':
        return <Navigate to="/admin/home" replace />;
      case 'cliente':
        return <Navigate to="/cliente/estados" replace />;
      case 'asesor':
        return <Navigate to="/asesor/home" replace />;
      case 'auditor':
        return <Navigate to="/auditor/home" replace />;
      case 'cajero':
        return <Navigate to="/cajero/home" replace />;
      case 'operaciones':
        return <Navigate to="/operaciones/calculadora" replace />;
      case 'contabilidad':
        return <Navigate to="/contabilidad/finanzas" replace />;
      default:
        return element;
    }
  }

  // Si no hay token, se muestra el elemento original
  return element;
};

export default ProtectedRoute;
